import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const PhotographsPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-376" data-mp="1mv94xf2vbq00">
      <Header data-id="element-377" data-mp="20vtnqb8s9lti" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-378" data-mp="20vahhrshwlvb">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-379" data-mp="1vxii6cpitxh3">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-380" data-mp="1vve9ziklacb0">
            <Navigation data-id="element-381" data-mp="2ald8jmg23pr0" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-382" data-mp="2aohmvcn8k1ve">
            <div className="max-w-2xl" data-id="element-383" data-mp="25od1b87h0gyb">
              <ul className="list-none leading-tight" data-id="element-384" data-mp="25peouc5oavwx">
                <li className="mb-[0.2rem]" data-id="element-385" data-mp="2jo4nvxc1z5nx">
                  <Link to="/body-not-thing" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-386" data-mp="2jl07m1lbcjgw">
                    The Body Is Not A Thing (2020 to 2024)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-387" data-mp="246f1cv85eu03">
                  <Link to="/quarry" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-388" data-mp="245nhghnwykpn">
                    The Quarry (2022)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-389" data-mp="2rv7zmyc8tdxv">
                  <Link to="/promise-never-forget" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-390" data-mp="2rtx1be1kgye5">
                    I Promise I'll Never Forget (2018 to 2021)
                  </Link>
                </li>
                <li className="mb-6" data-id="element-391" data-mp="16iwkg9hqszd3">
                  <Link to="/anchor" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-392" data-mp="16huw53bpugdf">
                    Anchor (2015)
                  </Link>
                </li>
                <li data-id="element-393" data-mp="3840d7mbiebpe">
                  <Link to="/notes" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-394" data-mp="385jw7kojv0uv">
                    Field Notes (Ongoing)
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default PhotographsPage;